export default {
  dataEstadosCidades: [],
  loadingGeral: {
    initialize: false
  }
};
